import { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import { useTranslation } from "react-i18next";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

//import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS
//import "ag-grid-community/styles/ag-theme-alpine.css"; // Theme CSS
import "../../../style/style-ag-grid.css";
import ModalFormInstalacion from "../../../components/form-instalacion";
import { createInstalacion, disableInstalacion, getListInstalacion } from "../../../api/api-instalacion";
import ModalFormDesinstalacion from "../../../components/form-desinstalar";
import { getWeekStartAndEnd, sharedNextPage } from "../../../utils/shared-functions";
import moment from "moment";
import { COLOR_AZUL_MAIN } from "../../../utils/const/colors-const";
import { STRING_COLOR_PRIMARIO } from "../../../utils/const/string-const";
// import "react-widgets/styles.css";
// import DatePicker from "react-widgets/DatePicker";
// import momentLocalizer from "react-widgets-moment";
// new momentLocalizer(moment);
// Register the modules
ModuleRegistry.registerModules([AllCommunityModule]);

let accesoBotonNuevo = '';


export default function ListInstalacion() {

  const { t } = useTranslation();
  const history = useHistory();
  const dateBeginInputRef = useRef(null);
  const dateEndInputRef = useRef(null);
  const [cargandoPage, setCargandoPage] = useState(true);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [showModalFormGenerico, setShowModalFormGenerico] = useState(false);
  const [showModalFormUnsinstall, setShowModalFormUnsinstall] = useState(false);
  const [formData, setFormData] = useState({});
  const [rowData, setRowData] = useState([]);

  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");

  const [primaryColor, setPrimaryColor] = useState(COLOR_AZUL_MAIN);
  const [isHovered, setIsHovered] = useState(false);
  const hoverColor = COLOR_AZUL_MAIN;

  const columnDefs = [
    {
      field: "acciones", headerName: t("column_actions"),
      cellRenderer: (params) => {
        // console.log('cellRenderer');
        // console.log(params);
        return (
          <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
            {params.data.fechainstalacion !== null &&
              String(params.data.fechainstalacion).length > 0 &&
              String(params.data.fechadesinstalacion).length > 0 &&
              params.data.fechadesinstalacion === null &&
              <button
                onClick={() => handleUninstall(params.data)}
                style={{
                  backgroundColor: "#DC3545",
                  color: "white",
                  border: "none",
                  padding: "5px 10px",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              >
                {t("label_uninstall")}
              </button>
            }
          </div>
        );
      }
    },
    { field: "id", headerName: "ID", hide: true },
    { field: "idempresaplataforma", headerName: 'ID EMPRESA PLATAFORMA', hide: true, filter: true, sortable: true, },
    { field: "empresaplataforma", headerName: t("column_company"), filter: true, sortable: true, },
    { field: "idactivo", headerName: 'ID ACTIVO', filter: true, sortable: true, },
    { field: "idequipo", headerName: 'ID EQUIPO', filter: true, sortable: true, },
    { field: "idsim", headerName: 'idsim', hide: true, filter: true, sortable: true, },
    { field: "sim", headerName: 'SIM', filter: true, sortable: true, },
    { field: "fechainstalacion", headerName: t("column_date_instalation"), filter: true, sortable: true, },
    { field: "ordentrabajoinstalacion", headerName: t("column_number_order_install"), filter: true, sortable: true, width: 250, },

    { field: "moneda", headerName: t("column_currency"), filter: true, sortable: true, width: 250, },

    { field: "fechadesinstalacion", headerName: t("column_date_desinstalation"), hide: false, filter: true, sortable: true, },
    { field: "ordentrabajodesinstalacion", headerName: t("column_number_order_uninstall"), filter: true, sortable: true, width: 250, },
  ];

  useEffect(() => {
    const mainColor = localStorage.getItem(STRING_COLOR_PRIMARIO);
    if (mainColor !== null) {
      setPrimaryColor(mainColor);
    }
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const { startDate, endDate } = getWeekStartAndEnd();
      setFechaInicio(startDate);
      setFechaFin(endDate);
      await searchInstalacion(startDate, endDate);
      setTieneAccesoAlModulo(true);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  };

  const searchInstalacion = async (inicio, fin) => {
    setCargandoPage(true);
    let objEnviar = {};
    objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
    objEnviar.dateBegin = moment(inicio).format("YYYY/MM/DD");
    objEnviar.dateEnd = moment(fin).format("YYYY/MM/DD");
    let lista = [];
    lista = await getListInstalacion(objEnviar, false, t);
    setRowData(lista);
    setCargandoPage(false);
  };

  const handleUninstall = async (data) => {
    try {
      // console.log("handleUninstall");
      // console.log(data);
      // return;
      setFormData({
        ...formData,
        id: data.id,
        idActivo: data.idactivo,
        idEquipo: data.idequipo,
        idSim: data.idsim,
        fechaDesinstalacion: "",
        numeroOrdenDesinstalacion: "",
      });
      setShowModalFormUnsinstall(true);
    } catch (err) {
      console.log("handleUninstall err");
      console.log(err);
    }
  };

  const handleAtrasClick = () => {
    // history.goBack();
    sharedNextPage("/administer", {}, history);
  };

  const onClickBtnSearch = async () => {
    searchInstalacion(fechaInicio, fechaFin);
  };

  const onConfirmFormCreate = async (formData) => {
    try {
      // console.log('onConfirmFormCreate');
      // console.log(formData);
      setShowModalFormGenerico(false);
      // return;

      const resp = await createInstalacion(formData);
      if (resp.error === false) {
        alert(t("alert_created_success"));
        setCargandoPage(true);
        searchInstalacion();
      }
      if (resp.error === true) {
        alert(resp.message);
        return;
      }


    } catch (err) {
      console.log('onConfirmForm err');
      console.log(err);
    }
  };

  const onConfirmFormUninstall = async (formData) => {
    try {
      // console.log('onConfirmFormUninstall');
      // console.log(formData);
      setShowModalFormUnsinstall(false);
      // return;
      const resp = await disableInstalacion(formData);
      if (resp.error === false) {
        alert(t("alert_update_success"));
        setCargandoPage(true);
        searchInstalacion();
      }
      if (resp.error === true) {
        alert(t("alert_failed") + "\n" + resp.message);
        return;
      }

    } catch (err) {
      console.log('onConfirmForm err');
      console.log(err);
    }
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="pt-4 px-4">
          <div className="flex justify-between">
            <label
              style={{
                fontWeight: 'bold',
              }}
            >
              {t("title_manage_installation")}
            </label>
            <div className="flex justify-center">
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={() => {
                  setFormData({
                    // ...formData,
                    id: 0,
                    idActivo: null,
                    idEquipo: null,
                    idSim: null,
                    fechaInstalacion: "",
                    numeroOrdenInstalacion: "",
                    montoInstalacion: 0,
                  });
                  setShowModalFormGenerico(true);
                }}
                style={{
                  display: accesoBotonNuevo,
                }}
              >
                {t("label_new")}
              </button>
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={(handleAtrasClick)}
              >
                {t("label_back")}
              </button>
              {/* <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                <Settings />
              </button> */}
            </div>
          </div>
          <div className="flex justify-between gap-4">
            {/* <div className="flex justify-between items-center "> */}
            <div className="flex flex-row justify-start">
              <div className="w-full sm:w-auto sm:flex-shrink-0 sm:mr-4 mb-4 sm:mb-0">
                <label htmlFor="fecha inicio" className="mb-2 font-bold">
                  {t("label_date_begin")}
                </label>
                <div
                  className="relative w-full cursor-pointer"
                  onClick={() => dateBeginInputRef.current?.showPicker()} // Open calendar on click
                >
                  <input
                    type="date"
                    ref={dateBeginInputRef}
                    value={fechaInicio}
                    onChange={(e) => {
                      setFechaInicio(e.target.value);
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>
              <div className="w-full sm:w-auto sm:flex-shrink-0 sm:mr-4 mb-4 sm:mb-0">
                <label htmlFor="fecha fin" className="mb-2 font-bold">
                  {t("label_date_end")}
                </label>
                <div
                  className="relative w-full cursor-pointer"
                  onClick={() => dateEndInputRef.current?.showPicker()} // Open calendar on click
                >
                  <input
                    type="date"
                    ref={dateEndInputRef}
                    value={fechaFin}
                    onChange={(e) => {
                      // console.log('date:', e.target.value);
                      setFechaFin(e.target.value);
                    }}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>
            </div>
            {/* </div> */}
            <div className="w-full sm:w-auto sm:flex-shrink-0">
              <label>
                &nbsp;
              </label>
              <button
                type="button"
                className={`${ESTILO_BOTON_MODAL_ACEPTAR} w-full`}
                style={{
                  backgroundColor: isHovered ? hoverColor : primaryColor,
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={() => onClickBtnSearch()}
              >
                {t("label_search")}
              </button>
            </div>
          </div>
          <div
            className="ag-theme-alpine pt-4"
            style={{
              height: "512px",
              width: "100%",
              "--ag-header-background-color": `${primaryColor}`,
            }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              pagination={true}
              rowHeight={50}
            />
          </div>
          {showModalFormGenerico &&
            <ModalFormInstalacion
              isOpen={showModalFormGenerico}
              onCancel={() => { setShowModalFormGenerico(false); }}
              onConfirm={onConfirmFormCreate}
              formData={formData}
              setFormData={setFormData}
              title={t("title_manage_installation")}
            />
          }
          {showModalFormUnsinstall &&
            <ModalFormDesinstalacion
              isOpen={showModalFormUnsinstall}
              onCancel={() => { setShowModalFormUnsinstall(false); }}
              onConfirm={onConfirmFormUninstall}
              formData={formData}
              setFormData={setFormData}
              title={t("title_manage_installation")}
            />
          }
        </div>
      );
    } catch (err) {
      console.log('ListarInstalacion render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
